/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DescriptionPage_ProductVariant as DescriptionPageProductVariant } from '__generated__/graphql-types';

import Imgix from 'js/components/Imgix';

import { Typography2 } from '@coursera/cds-core';

import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

import linkedInLogo from 'images/unified-description-page/linkedin-logo.png';

import _t from 'i18n!nls/xdp';

const styles = {
  itemTitle: () => css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    width: auto;
    height: 24px;
  `,
};

export const showShareableCertificate = (
  pageData: Pick<
    ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment,
    'certificates' | 'activeSpecialization' | 'primarySpecialization'
  >
) => {
  const hasCertificate = Boolean(pageData.certificates?.length);

  return (
    hasCertificate ||
    Boolean(pageData.activeSpecialization) ||
    pageData.primarySpecialization?.productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
    pageData.primarySpecialization?.productVariant === DescriptionPageProductVariant.ExternalCertificate
  );
};

const ShareableCertificateDetailItem = () => {
  return (
    <React.Fragment>
      <Imgix alt="" src={linkedInLogo} maxHeight={24} maxWidth={24} css={styles.icon} />
      <Typography2 variant="subtitleMedium" css={styles.itemTitle} component="div">
        {_t('Shareable certificate')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t('Add to your LinkedIn profile')}
      </Typography2>
    </React.Fragment>
  );
};

export default ShareableCertificateDetailItem;
